import React from "react";
import * as ReactDOMClient from "react-dom/client";
import { Amplify } from "aws-amplify";
import * as Sentry from "@sentry/react";
import { Integrations } from "@sentry/tracing";
import { BrowserRouter } from "react-router-dom";
import reportWebVitals from "./reportWebVitals";
import App from "./App";
import "./main.scss";
import amplifyConfig from "./aws-exports";

Amplify.configure(amplifyConfig);

Sentry.init({
  dsn: "https://1251fb271e4a4213ab633019118eb7a8@o1294964.ingest.sentry.io/6632304",
  normalizeDepth: 11,
  integrations: [new Integrations.BrowserTracing()],
  environment: process.env.REACT_APP_ENVIRONMENT,
  tracesSampleRate: 0.1,
});

Amplify.configure(amplifyConfig);

const container = document.getElementById("root");

if (container) {
  const root = ReactDOMClient.createRoot(container);

  root.render(
    <React.StrictMode>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </React.StrictMode>
  );
}
reportWebVitals();
